module.exports = __webpack_public_path__ + "static/media/Image-4.045aea96.jpg";